export const DEFAULT_TRAVEL_DURATION_MS = 900;
export const SEMANTIC_INTENT_DURATION_MS = 175;
export const PHYSICAL_INTENT_DURATION_MS = 300;
export const FAST_INTENT_DURATION_MS = 75;

export type CursorMode =
  | "idle"
  | "travel"
  | "frame-working-start"
  | "frame-working-mid"
  | "frame-working-end"
  | "frame-resting"
  | "point-resting";

export interface CursorAnimationState {
  x: number;
  y: number;
  mode: CursorMode;
}

export interface UseCursorAnimationOptions {
  /** The target frame ID this cursor should be on (null = idle by ticker). */
  targetFrameId: string | null;
  /** Bumped for each frame action so working animation can replay. */
  actionSeq?: number | null;
  onUpdate: (state: CursorAnimationState) => void;
  bandIndex?: number;
  /** User pointer captured when the cursor first appeared. */
  spawnAnchor?: { x: number; y: number } | null;
  /** Tracks the live pointer while the agent is waking or working. */
  followLivePointer?: boolean;
  /** Locks the cursor while its bubble is interactive. */
  freezePosition?: boolean;
  /** Decorative idle/rest drift; desktop runtime status stays steady. */
  ambientMotion?: boolean;
  /** Passive dock anchor when live pointer following is disabled. */
  passiveAnchor?: { x: number; y: number } | null;
  pointTarget?: { x: number; y: number } | null;
  pointSeq?: number | null;
  travelDurationMs?: number;
  completionToken?: string;
}
